module.exports = __webpack_public_path__ + "img/CellCycle-MELA_SpatialResearch.362005a2.png";